var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMaintenance = function SvgMaintenance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.177 9.514a5.824 5.824 0 1 1 0 11.647 5.824 5.824 0 0 1 0-11.647Zm.458 2.778-.004-.003a.648.648 0 0 0-.45-.187h-.008a.646.646 0 0 0-.454.19l-2.588 2.588a.647.647 0 1 0 .915.915l1.483-1.484v3.615a.647.647 0 0 0 1.295 0V14.31l1.483 1.484a.647.647 0 1 0 .915-.915l-2.587-2.588Z",
    fill: "#2F5EA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 16.632V4h20v4.632a7.449 7.449 0 0 0-2.047-.356 7.087 7.087 0 0 0-.175-.048V8.21c-.024 0-.048 0-.072-.002a6.969 6.969 0 0 0-.735-.142 2.237 2.237 0 0 1-.765-.473 2.05 2.05 0 0 1-.65-1.489H5.444c0 1.169-.988 2.106-2.222 2.106v4.21c.59 0 1.155.222 1.572.617.416.394.65.93.65 1.488h4.572a7.079 7.079 0 0 0 .175 2.106H1Zm12.887-7.904a7.015 7.015 0 0 0-3.695 4.638c-1.478-.354-2.525-1.526-2.525-3.05 0-1.79 1.444-3.127 3.333-3.158a3.358 3.358 0 0 1 2.887 1.57Z",
    fill: "#D1B896"
  })));
};
export default SvgMaintenance;